import React from 'react'
import { flatten, zip } from 'lodash'
import { TypeAnimation } from 'react-type-animation'


const strArray = str =>
  str?.split(' ')?.reduce((acc, el, idx) => {
    if (idx === 0) {
      acc.push(`${el} `)
    } else {
      acc.push(`${acc[idx - 1]}${el} `)
    }
    return acc
  }, [])

const waitArray = str => {
  return str?.split(' ').map((char, idx) => 1)
}

const CustomTypeAnimation = ({ content }) => (
  <TypeAnimation
    speed={100}
    sequence={flatten(
      zip(strArray(content), waitArray(content)),
      // [() => console.log('finished')],
    )}
    wrapper="span"
    cursor
    repeat={0}
  />
)

export default CustomTypeAnimation